import { useQuery } from "@tanstack/react-query";
import { BannerProps } from "@/services/banner/BannerService";
import { isProd } from "@/Env";
import { backendUrl } from "@/libs/backend-url";

const MINUTE = 60 * 1000;

async function getApi<T>(url: string): Promise<T | null> {
  try {
    const res = await fetch(url);
    if (res.ok) {
      return await res.json();
    }
    return null;
  } catch (e) {
    console.error(`BannerService.getApi(${url}) `, e);
    return null;
  }
}

async function getAllBanners(
  type: "Main" | "MOP" | "Game" | "EventPopup" | "GamePlatform",
  platform: string = "MOP",
): Promise<BannerProps[]> {
  const response = await getApi<{ message: BannerProps[] }>(
    backendUrl(
      "sdk",
      "/api/v1/banners",
      new URLSearchParams({ type, platform }),
    ),
  );
  return response?.message ?? [];
}

export const BannerQueryWebView = {
  banners: (
    type: "Main" | "Game" | "EventPopup" | "GamePlatform" = "Main",
    platform?: string,
  ) => ({
    queryKey: ["BannerQuery.banners", type],
    enabled: true,
    queryFn: () => getAllBanners(type, platform),
    staleTime: isProd ? 5 * MINUTE : undefined,
    gcTime: isProd ? 10 * MINUTE : undefined,
  }),
};

export function useBannersWebView(
  type: "Main" | "Game" | "EventPopup" | "GamePlatform" = "Main",
  platform?: string,
) {
  return useQuery(BannerQueryWebView.banners(type, platform));
}
